export default "__VITE_ASSET__OrsSOxPv__"